import { z } from 'zod';
import type { UserRef } from './tasks.js';

/** Группа согласующих: ставится в маршрут как участник («любой из группы» или «каждый»). */
export const approverGroupSchema = z.object({
  name: z.string().trim().min(1, 'Укажите название').max(200),
  description: z.string().trim().max(1000).nullable().optional(),
  memberIds: z.array(z.uuid()).max(500).default([]),
});
export type ApproverGroupInput = z.input<typeof approverGroupSchema>;

export interface ApproverGroupDto {
  id: string;
  name: string;
  description: string | null;
  members: UserRef[];
  /** Маршруты, где группа участвует. */
  usedIn: string[];
}
